module.exports = __webpack_public_path__ + "static/media/Home_Button@3x.2c82ac21.png";